<div class="main-container">
  <form class="ui form settings plan-page" @submit.prevent="continueToPayment">
    <div class="ui grid plan-page-h1-row">
      <div class="sixteen wide column">
        <h1>Select a plan to continue to use Smardie</h1>
      </div>
    </div>

    <div class="ui stackable grid plan-page-content-row">
      <div class="sixteen wide mobile eight wide computer column">
        <p class="body-large plan-page__heading">All plans unlock:</p>
        <ul class="plan-page__features">
          <li><img src="../../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Send unlimited quote &amp; invoices</li>
          <li><img src="../../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Add unlimited employees</li>
          <li><img src="../../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Smardie branding removed</li>
          <li><img src="../../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Priority support</li>
        </ul>
      </div>
      <div class="sixteen wide mobile eight wide computer column">
        <PlanFrequencySelect
          :model-value="interval"
          :options="frequencyOptions"
          @update:model-value="interval = $event"
        />
      </div>
    </div>

    <div class="ui divider plan-page-divider"></div>

    <div class="plan-page-actions">
      <button
        type="submit"
        class="plan-page-continue-btn ui primary button settings-save-btn"
      >
        Continue
      </button>
    </div>
  </form>
</div>
